import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);
const routers = [{
    path: "/",
    meta: {
        title: "首页|学术服务与知识创新平台"
    },
    component: resolve => require(["./views/index.vue"], resolve)
},
{
    path: "/course/:ID",
    meta: {
        title: "课程详细|学术服务与知识创新平台"
    },
    component: resolve => require(["./views/course.vue"], resolve)
},
{
    path: "/resource/:ID",
    meta: {
        title: "资源播放|学术服务与知识创新平台"
    },
    component: resolve => require(["./views/resource.vue"], resolve)
},
{
    path: "/dianzishu/:ID",
    meta: {
        title: "资源播放|学术服务与知识创新平台"
    },
    component: resolve => require(["./views/dianzishu.vue"], resolve)
},
{
    path: "/aboutUs",
    meta: {
        title: "关于我们"
    },
    component: resolve => require(["./views/aboutUs.vue"], resolve)
},
{
    path: "/contact",
    meta: {
        title: "联系方式"
    },
    component: resolve => require(["./views/contact.vue"], resolve)
},
{
    path: "/privacy",
    meta: {
        title: "隐私政策"
    },
    component: resolve => require(["./views/privacy.vue"], resolve)
},
{
    path: "/noResource",
    meta: {
        title: "图书资源"
    },
    component: resolve => require(["./views/noResource.vue"], resolve)
}
];
const RouterConfig = {
    mode: "hash",
    routes: routers
};

export default new Router(RouterConfig);